import { OrderStatus } from 'interfaces';

export const editableOrderStatuses: OrderStatus[] = ['WAITING', 'IN_PROGRESS', 'DELIVERED'];
